import type { ReportViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';
import type { OrganizationState } from '../../types';

export function toReportViewModel(item: ReportViewModel, o: OrganizationState): ReportViewModel {
  const employeeName =
    item.employeeUuid && o.employeesById[item.employeeUuid] ? o.employeesById[item.employeeUuid].name : '';
  const contactName =
    item.partnerContactUuid && o.contactsById[item.partnerContactUuid]
      ? o.contactsById[item.partnerContactUuid].firstName + ' ' + o.contactsById[item.partnerContactUuid].lastName
      : '';

  return Object.assign({}, item, {
    name: translateTemplateName(item.name),
    writtenByName: employeeName || contactName,
  });
}
